import { motion, useReducedMotion } from 'framer-motion'
import { AVATAR_SRC } from './Avatar'

const TRACK_WIDTH = 112
const FIGURE_SIZE = 24
const TRAIL_WIDTH = 28

/**
 * "K4ia tippt": the figure from the logo flies left to right through the
 * bubble, trailing a short cyan streak, then re-enters from the left. Replaces
 * the three bouncing dots (ADR 0011). With reduced motion the figure stays in
 * the middle; the accessible name says what is happening either way.
 */
export function FlyingFigure() {
  const reduceMotion = useReducedMotion()

  return (
    <span
      role="img"
      aria-label="K4ia tippt"
      className="relative block overflow-hidden"
      style={{ width: TRACK_WIDTH, height: FIGURE_SIZE + 6 }}
    >
      <motion.span
        className="absolute top-[3px] flex items-center"
        animate={
          reduceMotion
            ? { x: (TRACK_WIDTH - FIGURE_SIZE) / 2 - TRAIL_WIDTH }
            : { x: [-FIGURE_SIZE - TRAIL_WIDTH, TRACK_WIDTH] }
        }
        transition={
          reduceMotion ? { duration: 0 } : { duration: 1.6, repeat: Infinity, ease: 'easeInOut' }
        }
      >
        {!reduceMotion && (
          <span
            aria-hidden="true"
            className="h-1 rounded-full"
            style={{
              width: TRAIL_WIDTH,
              background: 'linear-gradient(to right, transparent, var(--color-accent))',
            }}
          />
        )}
        <motion.img
          src={AVATAR_SRC}
          alt=""
          draggable={false}
          className="select-none rounded-full"
          style={{
            width: FIGURE_SIZE,
            height: FIGURE_SIZE,
            marginLeft: reduceMotion ? TRAIL_WIDTH : 0,
          }}
          // Leans into the flight and bobs slightly, like it is gliding.
          animate={reduceMotion ? { y: 0, rotate: 0 } : { y: [0, -3, 0, 2, 0], rotate: 12 }}
          transition={
            reduceMotion ? { duration: 0 } : { duration: 0.8, repeat: Infinity, ease: 'easeInOut' }
          }
        />
      </motion.span>
    </span>
  )
}
